import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppSettings} from "../../config/config";
import {map} from 'rxjs/operators';
import { commonFunctionService } from "../utils/commonFunctions";

@Injectable()
export class AcademicsService{

  private _url = AppSettings.API_ENDPOINT;
  private URL_V3 = AppSettings.API_ENDPOINT_V3;
  headers:HttpHeaders;

  constructor(private http: HttpClient,private commonFunction : commonFunctionService){
    this.headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',localStorage.getItem('usertoken'));
  }

  // for fetching academics of school
  fetchAcademicList(){
    const params = {schoolId: localStorage.getItem('schoolinfo')};

    return this.http.post(this._url+'/academiclist',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }

  //for fetching metrics of school
  fetchAcademicMetrics(){
    const params = {schoolId: localStorage.getItem('schoolinfo')};

    return this.http.post(this._url+'/academiclist',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }

  //fetch available class
  getAvailableClass(){
    const params = {};

    return this.http.post(this._url+'/classManagement/listStandards',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }

  getClassSections(standardClassId){
    const params = {standardClassId:standardClassId};

    return this.http.post(this._url+'/classManagement/classmanagement_standard_SectionList',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }

  getClassStudents(standardClassId,sectionId,status,academicId){
    const params = {classStandardId:standardClassId,classSectionId:sectionId,status:status,page:1,academicId:academicId};
    return this.http.post(this._url+'/studentlist/getStudentsListAcademicPage',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }

  createAcademic(start,end,activeStatus){
    const params = {startDate:start,endDate:end,inActive:activeStatus};
    return this.http.post(this._url+'/academics/createAcademic',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }


   createNewAcademic(body){
    const params = body;
    return this.http.post(this._url+'/academics/createAcademic',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }

  /*  Academic transition */

  getCurrentAndNextAcademic(){
    const params = {};
    return this.http.post(this._url+'/promote/academics/get/currentAndNext',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }

  getNextClassOfClass(){
    const params = {};
    return this.http.post(this._url+'/promote/academics/get/nextclassofclass',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }

  getPromotionListByClass(classId){
    const params = {classId:classId};
    return this.http.post(this._url+'/promote/academics/promotionlist/classId/class',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }

  updateStudentPromotionList(toClassId,promoteId){
    const params = {toClassId:toClassId,idSchoolNextAcademicPromotionList:promoteId};
    return this.http.post(this._url+'/promote/academics/update/promotionlist',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }


  processPromoteStudent(reqObj){
    const params = reqObj;
    return this.http.post(this._url+'/promote/academics/process/nextacademic/school',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }

  promoteStudentResult(){
    const params = {};
    return this.http.post(this._url+'/promote/academics/process/result',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }

  createFinancialTerm(reqObj){
    const params = reqObj;
    return this.http.post(this._url+'/manageFees/academic/financialterm/create',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }

  getFinancialTerms(academicId){
    const params = {academicId:academicId};
    return this.http.post(this._url+'/manageFees/academic/financialterm/list',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }

  updateFinancialTerm(reqObj){
    const params = reqObj;
    return this.http.post(this._url+'/manageFees/academic/financialterm/update',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }

  deleteFinancialTerm(termId,academicId){
    const params = {termId:termId,academicId:academicId};
    return this.http.post(this._url+'/manageFees/academic/financialterm/delete',
      params,{ headers: this.headers})
      .pipe(map(res => res));
  }

  
  changeIncludeTermFee(body){
      return this.http.put(this.URL_V3+'/update/late/fee/setting/for/transport/fees',body, {
      headers: this.commonFunction.appendHeader()
    }).pipe(map(res => res));
  }
}

